
export const VisitState = {
   NOT_DONE: "not_done",
    NEW: "new",
    INCOMPLETE: "incomplete",
    COMPLETE: "completed"
} as const
